module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAQBAMAAAAc1rnfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTF1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXbdM3n0AAAAKdFJOUwDwVbolCHig10DU0i6hAAAACXBIWXMAAABIAAAASABGyWs+AAAAkElEQVQY02NgIAisTJE4wYsZGBxXOMD5LF0iDAxMq4TgAoqrFICk1ioTKN951TIQVbVqlVEAkGZVXrVqIVA7+0L1VauEk5TUDFetKrGSZGDIkmRwl1oFAgtLGIIXMjBoTGBgCFrVuEpiVSpQXxrENLbFILMMEO5xXAkiFiEEqgpAyhYGwAUEwY61QAi44PMsAF42IhcS2Y62AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/user/invisible.png
// module id = 244
// module chunks = 0